import { render, staticRenderFns } from "./billEdit.vue?vue&type=template&id=65b00027&scoped=true&"
import script from "./billEdit.vue?vue&type=script&lang=tsx&"
export * from "./billEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./billEdit.vue?vue&type=style&index=0&id=65b00027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b00027",
  null
  
)

export default component.exports